// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"69fd5a48","787":"5e281ce2"}[chunkId] + ".chunk.js";
};